import { IppicaIppodromoDto, IppicaNazioneDto } from 'types/swagger';
import React, { useEffect, useState } from 'react';
import { capitalize, isTruthy } from 'utility/functions';
import { selectIsMenuLoading, selectIsTodayExpanded, selectMenuData } from 'features/ippica/selectors';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import { IppicaNavAccordion } from '../ippicaNavAccordion';
import { IppicaNavContentEmpty } from '../ippicaNavContentEmpty';
import { SimpleAccordion } from 'components/simpleAccordion';
import { SkeletonArea } from 'components/skeletonArea';
import { TabValue } from 'features/ippica/types';
import styles from '../IppicaNav.module.scss';
import { todayMenuItemToggle } from 'features/ippica/ippicaSlice';
import { useIsAuthenticated } from 'hooks/useIsAuthenticated';

export interface IppicaNavTabTodayProps {
  mieiIppodromi: any;
}

interface IppicaIppodromoWrapperProps extends IppicaIppodromoDto {
  codiceProgramma: number;
  index: number;
  nazioneIndex: number;
}

const IppicaIppodromoWrapper: React.FC<IppicaIppodromoWrapperProps> = ({
  codiceProgramma,
  codiceRiunione,
  corse,
  nazioneIndex,
  index,
  descrizioneRiunione,
}) => {
  const dispatch = useAppDispatch();
  const [isFirstOpened, setIsFirstOpened] = useState<boolean>(false);
  const itemKey = `${codiceProgramma}#${codiceRiunione}`;

  const isOpen = useTypedSelector((st) => selectIsTodayExpanded(st, itemKey));

  useEffect(() => {
    if (index !== 0 && nazioneIndex !== 0) {
      return;
    } else {
      setIsFirstOpened(true);
    }
  }, []);
  const accordionToggleHandler = () => {
    if (index === 0 && nazioneIndex === 0) {
      setIsFirstOpened((prevState) => !prevState);
    }
    dispatch(todayMenuItemToggle(itemKey));
  };

  return (
    <IppicaNavAccordion
      text={capitalize(descrizioneRiunione)!}
      corse={corse}
      isOpen={index === 0 && nazioneIndex === 0 ? isFirstOpened : isOpen}
      codiceProgramma={codiceProgramma}
      onToggle={accordionToggleHandler}
    />
  );
};

const IppicaNazioneWrapper: React.FC<IppicaNazioneDto & { nazioneIndex: number }> = ({
  image,
  titolo,
  ippodromi,
  nazioneIndex,
}) => {
  const dispatch = useAppDispatch();

  const accordionToggleHandler = () => {
    dispatch(todayMenuItemToggle(titolo));
  };

  return (
    <SimpleAccordion
      title={isTruthy(titolo?.length) ? titolo! : '-'}
      image={image ? image : undefined} // TODO check
      isOpen={true}
      layoutType={'sidenav'}
      onToggle={accordionToggleHandler}
      className={styles.accordion}
      removeIcon
    >
      <div className={styles.content}>
        {ippodromi?.map((ippodromo, index) => (
          <IppicaIppodromoWrapper
            key={`${titolo}-${ippodromo.codiceRiunione}`}
            {...ippodromo}
            index={index}
            nazioneIndex={nazioneIndex}
            codiceProgramma={ippodromo.codiceProgramma}
          />
        ))}
      </div>
    </SimpleAccordion>
  );
};

export const IppicaNavTabToday = ({ mieiIppodromi }: IppicaNavTabTodayProps) => {
  const isAuthenticated = useIsAuthenticated();
  const type = TabValue.TODAY;

  const data = useTypedSelector((state) => selectMenuData(state, type));
  const isLoading = useTypedSelector((state) => selectIsMenuLoading(state, type));

  const renderContent = () => {
    if (isLoading && !isTruthy(data?.length)) return <SkeletonArea height={'58.8'}></SkeletonArea>;

    if (isTruthy(data?.length)) {
      return (
        <React.Fragment key={TabValue.TODAY}>
          {data.map((x, index) => (
            <IppicaNazioneWrapper key={x.titolo} {...x} nazioneIndex={index} />
          ))}
        </React.Fragment>
      );
    }

    return <IppicaNavContentEmpty key={TabValue.TODAY} className={styles.marginVertical} />;
  };

  return (
    <React.Fragment>
      {/* TODO ADD IN FUTURE */}
      {/* {isAuthenticated && (
        <SimpleAccordion title={`I miei ippodromi (${mieiIppodromi?.length})`} layoutType={'sidenav'}>
          <div className={styles.content}>
            {mieiIppodromi?.map(({ corse, titolo, codiceProgramma }, index) => (
              <IppicaNavAccordion
                key={`${titolo}_${index}`}
                text={titolo.length !== 0 ? titolo : '-'}
                corse={corse}
                codiceProgramma={codiceProgramma}
              />
            ))}
          </div>
        </SimpleAccordion>
      )} */}
      {renderContent()}
    </React.Fragment>
  );
};
